import { Component, OnInit, ViewChild, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';
import { ModalDirective } from 'ng2-bootstrap/components/modal/modal.component';

import { LoaderEvent } from './../../shared/message.event';
import { CONSTANT_VALUES } from '../../constants/constant-values';
import { UtilityFunctions } from '../../shared/utility-functions';
@Component({
    selector: 'app-disable-group',
    templateUrl: './disable-group.component.html',
    styleUrls: ['./disable-group.component.css'],
    providers: [LoaderEvent],
    exportAs: 'disableGroupPopupObj'
})
export class DisableGroupComponent implements OnInit {
    public actionObj;
    @ViewChild('childModal') childModal: ModalDirective;
    @Input() message = '';
    @Input() popupTitle;
    @Input() cancleButton;
    @Output() notify = new EventEmitter<boolean>();
    @Output() notifyDelete = new EventEmitter<boolean>();
    @Input() deleteMessage;
    @Output() disableFacility = new EventEmitter<any>();
    @Input() facilityList = [];
    private popUpMessage = '';
    private validate;
    private disableStartTime = '';
    private disableEndTime = '';
    private startMinDate = new Date();
    private selectedFacility = '';
    private confirmMessage = '';
    private startMaxDate;
    private endMinDate = new Date();
    private minDate = new Date();
    private utilityFunctions = new UtilityFunctions();
    constructor(private loaderEvent: LoaderEvent) {
        this.actionObj = {
            facility: '',
            reason: '',
            startTime: '',
            endTime: '',
            action: ''
        };
        this.validate = {
            facility: '',
            flag: true,
            reason: '',
            startTime: '',
            endTime: '',
            dateMatchFlag: false
        };
    }

    /**
     * Show disable group popup
     */
    public showChildModal(): void {
        try {
            this.actionObj.facility = '';
            this.actionObj.reason = '';
            this.actionObj.startTime = '';
            this.actionObj.endTime = '';
            this.startMaxDate = '';
            this.endMinDate = new Date();
            this.minDate = new Date();
            this.validate.facility = '';
            this.validate.reason = '';
            this.validate.startTime = '';
            this.validate.endTime = '';
            this.childModal.config.backdrop = false;
            this.childModal.config.keyboard = false;
            this.utilityFunctions.setBackGroundBlack();
            this.childModal.show();
        } catch (e) {
            console.log(e);
        }
    }

    public hideChildModal(): void {
        try {
            this.utilityFunctions.removeBackGroundBlack();
            this.childModal.hide();
        } catch (e) {
            console.log(e);
        }
    }

    ngOnInit() {
    }

    onClickCancel() {
        try {
            this.notify.emit(false);
        } catch (e) {
            console.log(e);
        }
    }

    /**
     * Validation on start and end time for disable group
     */
    changeEndMinDate(startDate) {
        this.endMinDate = startDate;
        this.actionObj.endTime = startDate;
    }

    /**
     * Facility name will change on selection to disable group
     */
    facilityChange(facilityId) {
        if (facilityId && (facilityId + '').indexOf(':') > -1) {
            facilityId = facilityId.split(':')[1].trim();
            this.selectedFacility = facilityId;
        }
    }

    onClickOkDisable(dateMissMatchPopUpObj, confirmPopUpObj) {
        let start, end;
        if (this.validateFieldsDisablePopup('')) {
            this.actionObj.action = 'disable';
            this.disableFacility.emit(this.actionObj);
            this.hideChildModal();
        }
    }

    /**
     * Validation of disable group object
     */
    validateFields() {
        try {
            this.validate.flag = true;
            this.validate.dateMatchFlag = true;
            if (!(this.actionObj.facility + '').trim()) {
                this.validate.facility = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
                this.validate.flag = false;
            }
            if (!(this.actionObj.startTime + '').trim() || this.actionObj.startTime == null) {
                this.validate.startTime = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
                this.validate.flag = false;
            }
            if (!(this.actionObj.endTime + '').trim() || this.actionObj.endTime == null) {
                this.validate.endTime = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
                this.validate.flag = false;
            }
            if ((this.actionObj.startTime + '').trim() && (this.actionObj.endTime + '').trim()) {
                if (new Date(this.actionObj.startTime).getTime() <= new Date(this.actionObj.endTime).getTime()) {
                } else {
                    this.validate.dateMatchFlag = false;
                    this.validate.flag = false;
                }
            }
            if (!(this.actionObj.reason + '').trim()) {
                this.validate.reason = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
                this.validate.flag = false;
            }
        } catch (e) {
            console.log(e);
        }
        return this.validate;
    }
    /**
     * Validate fields
     *
     * @param {any} para
     * @returns
     *
     * @memberof DisableGroupComponent
     */
    validateFieldsDisablePopup(para) {
        let flag = true;
        switch (para) {
            case 'facility':
                let that = this;
                setTimeout(function () {
                    if (!(that.actionObj.facility + '').trim()) {
                        that.validate.facility = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
                        flag = false;
                    } else {
                        that.validate.facility = '';
                        flag = true;
                    }
                }, 0);
                break;
            case 'reason':
                if (!(this.actionObj.reason + '').trim()) {
                    this.validate.reason = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
                    flag = false;
                } else {
                    this.validate.reason = '';
                    flag = true;
                }
                break;
            case 'startTime':
                if (this.actionObj.startTime) {
                    this.validate.startTime = '';
                    flag = true;
                } else {
                    this.validate.startTime = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
                    flag = false;
                }
                break;
            case 'endTime':
                if (this.actionObj.endTime) {
                    this.validate.endTime = '';
                    flag = true;
                } else {
                    this.validate.endTime = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
                    flag = false;
                }
                break;
            case '':
                if (!(this.actionObj.facility + '').trim()) {
                    this.validate.facility = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
                    flag = false;
                } else {
                    this.validate.facility = '';
                }
                if (!(this.actionObj.reason + '').trim()) {
                    this.validate.reason = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
                    flag = false;
                } else {
                    this.validate.reason = '';
                }
                if (!new Date(this.actionObj.startTime).getTime()) {
                    this.validate.startTime = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
                    flag = false;
                } else {
                    this.validate.startTime = '';
                }
                if (!new Date(this.actionObj.endTime).getTime()) {
                    this.validate.endTime = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
                    flag = false;
                } else {
                    this.validate.endTime = '';
                }
                if ((this.actionObj.startTime + '').trim() && (this.actionObj.endTime + '').trim()) {
                    if (new Date(this.actionObj.startTime).getTime() <= new Date(this.actionObj.endTime).getTime()) {
                    } else {
                        this.validate.dateMatchFlag = false;
                        flag = false;
                    }
                }
        }
        return flag;
    }

    changeStartEndDate(minEndDate) {
        this.startMaxDate = minEndDate;
    }

    /**
     * Enable group for specific facility
     */
    onClickOkEnable() {
        let flag = this.validateFieldsDisablePopup('facility');
        if ((this.actionObj.facility + '').trim()) {
            this.actionObj.reason = '';
            this.actionObj.startTime = '';
            this.actionObj.endTime = '';
            this.actionObj.action = 'enable';
            this.disableFacility.emit(this.actionObj);
            this.hideChildModal();
        } else {
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/group/disable-group/disable-group.component.ts